import { secondDatabase } from "../../../../config/firebase";

const checkIfExists = async (invoice, projectsObject) => {
  const thisPoNumber = invoice.requestItemData.poNumber;

  const fetchPromises = projectsObject.map(async (project) => {
    const path = `${project.firmDetailsID}/MRNRequests/${project.projectID}/${thisPoNumber}`;
    const ref = secondDatabase.ref(path);

    try {
      const snapshot = await ref.once("value");

      if (snapshot.exists()) {
        return {
          exists: true,
          data: snapshot.val(),
        };
      }
    } catch (error) {
      console.error(`Error checking path ${path}:`, error);
    }

    return null;
  });

  const results = await Promise.all(fetchPromises);

  // Return the first match found
  for (const result of results) {
    if (result && result.exists) {
      return result;
    }
  }

  return {
    exists: false,
    data: null,
  };
};

export default checkIfExists;
